import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import * as VueGoogleMaps from "vue2-google-maps";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "./assets/scss/style.scss";

import axios from "./axios.js";

// Styles: SCSS
//_vueSelect
import "./assets/_vueSelect.scss";
Vue.prototype.$http = axios;

// Globally Registered Components
import "./globalComponents.js";

// global components
import GlobalComponents from "./globalComponents";
Vue.use(GlobalComponents);

import moment from "moment";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

// You need a specific loader for CSS files
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

import CustomButton from "@/components/CustomButton.vue";
Vue.component("CustomButton", CustomButton);

Vue.component("datetime", Datetime);

// import { initFacebookSdk } from "./_helpers/init-facebook-sdk.js";

// initFacebookSdk();

import VueYoutube from "vue-youtube";

Vue.use(VueYoutube);

import Toasted from "vue-toasted";

const options = {
    // icon: {
    //   name: "watch",
    //   after: true, // this will append the icon to the end of content
    // },
    action: {
        text: "Login",
        onClick: (e, toastObject) => {
            router.push("/login");
            toastObject.goAway(0);
        },
    },
};
Vue.use(Toasted, options);

router.afterEach(() => {
    const contentWrapper = document.querySelector(".v-content__wrap");
    if (contentWrapper !== null) {
        contentWrapper.scrollTop = 0;
        window.scroll(0, 0);
    }
});

// i18n
import i18n from "./i18n/i18n";

// VeeValidate
/*eslint-disable */
import VeeValidate from "vee-validate";

import ARvalidationMessages from "vee-validate/dist/locale/ar";
import ENvalidationMessages from "vee-validate/dist/locale/en";
import FRvalidationMessages from "vee-validate/dist/locale/fr";

Vue.use(VeeValidate, {
    // i18nRootKey: "validations", // customize the root path for validation messages.
    i18n,
    dictionary: {
        ar: ARvalidationMessages,
        en: ENvalidationMessages,
        fr: FRvalidationMessages,
    },
});
VeeValidate.Validator.extend("lowCase", {
    getMessage: (field) =>
        `The password must contain at least: 1 lowercase letter`,
    validate: (value) => {
        var strongRegex = new RegExp("^(?=.*[a-z])");
        return strongRegex.test(value);
    },
});
VeeValidate.Validator.extend("UpCase", {
    getMessage: (field) =>
        `The password must contain at least: 1 uppercase letter`,
    validate: (value) => {
        var strongRegex = new RegExp("^(?=.*[A-Z])");
        return strongRegex.test(value);
    },
});

VeeValidate.Validator.extend("number", {
    getMessage: (field) => `The password must contain at least: 1 number`,
    validate: (value) => {
        var strongRegex = new RegExp("^(?=.*[0-9])");
        return strongRegex.test(value);
    },
});
VeeValidate.Validator.extend("SpecialChar", {
    getMessage: (field) =>
        `The password must contain at least: 1 special character`,
    validate: (value) => {
        var strongRegex = new RegExp("^(?=.*[!@#$%^&*])");
        return strongRegex.test(value);
    },
});
/* eslint-enable*/
// axios

// import style (<= Swiper 5.x)

Vue.config.productionTip = false;
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "",
//     libraries: ["places"],
//   },
// });
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");